// To deserialize we unescape and decode with JSON

export const deserialize_and_pick = function (state_string, possible_elements) {
  if (
    state_string === null ||
    typeof state_string === "undefined" ||
    state_string === ""
  ) {
    return [];
  }
  const states = state_string.split("|");
  const lowercase_states = states.map((el) => el.toLowerCase());
  function filter_element(el) {
    if (typeof el.id == "undefined") {
      return false;
    }
    return lowercase_states.includes(el.id.toString().toLowerCase());
  }
  var result = possible_elements.filter(filter_element);
  return result;
};

export const serialize = function (elements) {
  if (elements === null) {
    return "";
  }
  return elements.map((el) => el.id.toString()).join("|");
};

export const extract_matchers = function (title_string, possible_elements) {
  const title_string_lowercase = title_string.toLowerCase();
  return possible_elements.filter((el) => {
    return new RegExp(el.id, "i").test(title_string_lowercase);
  });
};
